module.exports = __webpack_public_path__ + "img/image92.dd38d0db.jpg";